import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-queue" }
const _hoisted_2 = { class: "customer-queue-header" }
const _hoisted_3 = { class: "customer-queue-info" }
const _hoisted_4 = { class: "customer-queue-container" }
const _hoisted_5 = { class: "customer-queue-content-title" }
const _hoisted_6 = { class: "customer-queue-content-number" }
const _hoisted_7 = { class: "customer-queue-end-button" }

import vue from '../../../adapter-vue';
import { IConversationModel, StoreName, TUIStore, TUITranslateService } from '../../../@aidesk/uikit-engine';
import { getTo, leaveQueuing } from '../../../utils/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  queueNumber: {
    type: Number,
    default: 0
  },
},
  emits: ['closeQueuePage'],
  setup(__props, { emit: __emit }) {

const { ref, onMounted, onUnmounted } = vue;
const currentConversation = ref<IConversationModel>();
const isClicked = ref(false);
const props = __props;
const emits = __emit;
onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
};

const leaveQueue = () => {
  if (isClicked.value) {
    return;
  }
  isClicked.value = true;
  leaveQueuing(getTo(currentConversation.value));
  emits('closeQueuePage');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("AIDesk.排队等待中")) + "... ", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("AIDesk.排队等待话术")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(TUITranslateService).t("AIDesk.当前前方排队人数")), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(props.queueNumber), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(['customer-queue-end-button-content', _unref(isClicked) ? 'button-clicked' : '']),
        onClick: leaveQueue
      }, _toDisplayString(_unref(TUITranslateService).t("AIDesk.结束排队")), 3)
    ])
  ]))
}
}

})